import React from "react";
import { Route, Switch } from "react-router";
import { connect } from "react-redux";

import AdminSideBar from "../adminPanel/AdminSideBar";
import AdminHeader from "../adminPanel/AdminHeader";
import AdminPage from "../adminPanel/AdminPage";
import PointsPanel from "../adminPanel/Points/PointsPanel";
import CompaniesPanel from "../adminPanel/Companies/CompaniesPanel";
import CompanySettings from "../adminPanel/Companies/CompanySettings";
import Reports from "../adminPanel/Reports/Reports";
import EditCard from "components/pages/settings/IsrealCompanies/EditCard";
import SystemSettings from "components/pages/settings/SystemSettings";
import ServiceCategoriesSettings from "components/adminPanel/Settings/ServiceCategoriesSettings";

import ProvidersPage from "components/adminPanel/Settings/pages/ProvidersPage";
import OperatorsPage from "components/adminPanel/Settings/OperatorsPage";
import CommissionsPage from "components/adminPanel/Settings/pages/CommissionsPage";
import GiftCardsPage from "components/adminPanel/Settings/pages/GiftCardsPage";
import MessagingPage from "components/adminPanel/Settings/pages/MessagingPage";
import AccessPage from "components/adminPanel/Settings/pages/AccessPage";
import ToolsPage from "components/adminPanel/Settings/pages/ToolsPage";

// The settings area is nine pages. The old one-page-per-provider URLs still
// resolve, landing on the tab that replaced them, so bookmarks keep working.
const tab = (Page, key) => {
  const Landing = () => <Page defaultTab={key} />;
  Landing.displayName = `${Page.name}:${key}`;
  return Landing;
};

const adminRoutes = [
  { path: "/admin", component: AdminPage },

  { path: "/admin/providers", component: ProvidersPage },
  { path: "/admin/eprs", component: tab(ProvidersPage, "eprs") },
  { path: "/admin/erps", component: tab(ProvidersPage, "eprs") },
  { path: "/admin/azy", component: tab(ProvidersPage, "azy") },

  { path: "/admin/operators", component: OperatorsPage },

  { path: "/admin/commissions", component: CommissionsPage },
  { path: "/admin/madaCommission", component: tab(CommissionsPage, "mada") },
  { path: "/admin/paltelCommission", component: tab(CommissionsPage, "paltel") },
  { path: "/admin/jawwalInvoiceCommission", component: tab(CommissionsPage, "jawwal_invoice") },
  { path: "/admin/nedcoCommission", component: tab(CommissionsPage, "nedco") },
  { path: "/admin/reflect", component: tab(CommissionsPage, "reflect") },
  { path: "/admin/paltel", component: tab(CommissionsPage, "paltel_settings") },
  { path: "/admin/jawwalInvoiceSettings", component: tab(CommissionsPage, "jawwal_invoice_settings") },
  { path: "/admin/mada", component: tab(CommissionsPage, "mada_settings") },
  { path: "/admin/coolnet", component: tab(CommissionsPage, "coolnet_settings") },

  { path: "/admin/giftcards", component: GiftCardsPage },
  { path: "/admin/Mintroute", component: tab(GiftCardsPage, "mintroute") },
  { path: "/admin/hypermedia", component: tab(GiftCardsPage, "hypermedia") },
  { path: "/admin/gemzo", component: tab(GiftCardsPage, "gemzo") },
  { path: "/admin/pubg", component: tab(GiftCardsPage, "pubg") },

  { path: "/admin/messaging", component: MessagingPage },
  { path: "/admin/whatsapp", component: tab(MessagingPage, "whatsapp") },
  { path: "/admin/ads", component: tab(MessagingPage, "ads") },

  { path: "/admin/services", component: ServiceCategoriesSettings },

  { path: "/admin/access", component: AccessPage },
  { path: "/admin/permissions", component: tab(AccessPage, "permissions") },
  { path: "/admin/loginCode", component: tab(AccessPage, "loginCode") },

  { path: "/admin/tools", component: ToolsPage },
  { path: "/admin/liveLog", component: tab(ToolsPage, "liveLog") },
  { path: "/admin/deleteTrans", component: tab(ToolsPage, "deleteTrans") },
  { path: "/admin/allCompanies", component: tab(ToolsPage, "allCompanies") },
  { path: "/admin/arabBank", component: tab(ToolsPage, "arabBank") },
  { path: "/admin/translate", component: tab(ToolsPage, "translate") },

  { path: "/admin/system", component: SystemSettings },

  // Not settings, but they live under /admin.
  { path: "/admin/Points", component: PointsPanel },
  { path: "/admin/Companies", component: CompaniesPanel },
  { path: "/admin/Company/:id", component: CompanySettings },
  { path: "/admin/Reports", component: Reports },
  { path: "/admin/editSettings", component: EditCard },
];

const AdminRoutes = ({ isDarktheme }) => {
  return (
    <Switch>
      <section className="row item-translate">
        <div className="admin-panel-Page">
          <AdminSideBar />
          <div style={{ width: "100%" }}>
            <AdminHeader />
            <div
              className={
                !isDarktheme
                  ? "col-lg-11 col-sm-12  white"
                  : "col-lg-11 col-sm-12  dark"
              }
              style={{ padding: "25px" }}
            >
              {adminRoutes.map((r) => (
                <Route key={r.path} exact path={r.path} component={r.component} />
              ))}
            </div>
          </div>
        </div>
      </section>
    </Switch>
  );
};

const mapStateToProps = ({ darkTheme: { isDarktheme } }) => {
  return {
    isDarktheme,
  };
};
export default connect(mapStateToProps, null)(AdminRoutes);
